import {
  LOGOUT,
  LOGIN_SUCCESS,
  UPDATE_ONBOARDING_SUCESS,
  LOGOUT_SUCCESS,
  PHONE_AUTH,
  TC_CHECKED,
  UPDATE_EDITED_DETAILS,
  UPLOAD_PROFILE_IMAGE,
  SET_DEFAULT_ADDRESS,
  SET_SELECTED_VEHICLE_REF,
  UPDATE_USER_SETTINGS,
  MODIFY_TOKEN,
  SAVE_WORKSHOP_STANDARD,
} from "../Types";
import { CALL_API } from "../api.middleware";
import { replace } from "connected-react-router";

export const signIn = (payload) => {
  return {
    data: payload,
    type: LOGIN_SUCCESS,
  };
};

export const modifyToken = (payload) => {
  return {
    data: payload,
    type: MODIFY_TOKEN,
  };
};

export const updateEditedUserDetails = (payload) => {
  return {
    data: payload,
    type: UPDATE_EDITED_DETAILS,
  };
};
export const uploadProfileImage = (payload) => {
  return {
    data: payload,
    type: UPLOAD_PROFILE_IMAGE,
  };
};
export const updateOnBoarding = (payload) => {
  return {
    data: payload,
    type: UPDATE_ONBOARDING_SUCESS,
  };
};

export const logoutUser = () => {};

export function logout() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

export const phoneAuth = (data = {}) => {
  return {
    type: PHONE_AUTH,
    data,
  };
};

export const tcIsChecked = (data = false) => {
  return {
    data,
    type: TC_CHECKED,
  };
};

export const setDefAddress = (payload) => {
  return {
    data: payload,
    type: SET_DEFAULT_ADDRESS,
  };
};

export const setSelectedVehicle = (payload) => {
  return {
    data: payload,
    type: SET_SELECTED_VEHICLE_REF,
  };
};

export const updateUserSettings = (payload) => {
  return {
    data: payload,
    type: UPDATE_USER_SETTINGS,
  };
};

export const saveWorkshopStandard = (payload) => {
  return {
    data: payload,
    type: SAVE_WORKSHOP_STANDARD,
  };
};
